var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: _vm.sectionClass }, [
    _c("div", { staticClass: "section-content" }, [
      _c("div", { staticClass: "has-text-centered" }, [
        _c("div", { staticClass: "title is-spaced" }, [
          _vm._v(_vm._s(_vm.$t("home.section_video.title"))),
        ]),
      ]),
      _c("div", { staticClass: "columns column-text-side" }, [
        _vm._m(0),
        _c("div", { staticClass: "column" }, [
          _c("p", { staticClass: "subtitle subtitle-left-padding" }, [
            _vm._v(
              _vm._s(_vm.$t("home.section_video.content1") + " ") +
                "\n" +
                _vm._s(_vm.$t("home.section_video.content2"))
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "gif-workout-container" }, [
        _c("img", {
          staticClass: "landscape-phone-gif",
          attrs: { src: "/img/phone_landscape.png" },
        }),
        _c("div", { staticClass: "gif-workout" }, [
          _c("img", { attrs: { src: "/img/workout-320p.gif" } }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }